<!-- 招聘信息详情 -->
<template>
    <div v-loading="loading" style="background-color: rgba(0,0,0,0.05);color:#292c32;width:100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div v-if="jobPublishDetail.length>0" style="margin:30px 0;width:900px;box-sizing: border-box;padding: 20px 20px;background-color: #ffffff;display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div  style="position: relative;;width:100%;display: flex;flex-direction: column;align-items: flex-start;justify-content: center;">
                <div style="font-size:14px;color:#89909e;height:30px;width:100%;line-height: 30px;">
                    发布时间：{{jobPublishDetail[0].createTime.substring(0,10)}}
                </div>
                <div style="width:100%;height:50px;line-height: 40px;">
                    <span style="padding:5px 10px;background-color: #ff6b6b;color:#fff;font-size: 12px;">{{jobPublishDetail[0].levelName}}</span>
                    <span style="padding:5px 10px;color:#333333;font-size: 18px;">{{jobPublishDetail[0].jobTitle}}</span>
                </div>
                <div style="font-size:14px;color:#89909e;height:30px;line-height: 30px;width:100%;">
                        {{jobPublishDetail[0].deptTypeName}}》{{jobPublishDetail[0].parentDeptName}}》{{jobPublishDetail[0].deptName}}
                </div>

                <div style="font-size:14px;color:#89909e;height:30px;line-height: 35px;width:100%;">
                    {{jobPublishDetail[0].majorName}} | {{jobPublishDetail[0].typeName}} | {{jobPublishDetail[0].needNumber}}人
                </div>
                <div style="font-size:14px;color:#89909e;height:30px;width:100%;line-height: 30px;">
                    <div>{{jobPublishDetail[0].address}}</div>              
                </div>
                
                <div @click="goJobEdit(jobPublishDetail[0].id)" style="cursor: pointer;position:absolute;right:10px;bottom:10px;padding:8px 20px;background-color: #2d8cf0;color:#fff;font-size:14px;font-weight: 500;">
                    职位申请
                </div>                
            </div>  
            <div style="width:100%;margin-top:10px;">
                <div style="width:100%;display: flex;align-items: center;">
                    <p style="font-size:16px;width:70px;">职位描述</p>
                    <p style="width:calc(100% - 70px);height:1px;background-color: #eeeeee;"></p>
                </div>
                <div style="font-size:14px;color:#292c32;">岗位职责:</div>
                <div v-html="jobPublishDetail[0].jobDuty" style="width:100%;line-height: 15px;font-size:14px;font-weight: 400;;">
                </div>
                <div style="font-size:14px;color:#292c32;">任职资格:</div>    
                <div v-html="jobPublishDetail[0].jobCompetence" style="width:100%;line-height: 15px;font-size:14px;font-weight: 400;;">
                </div>

            </div>          
            <div style="width:100%;margin-top:10px;">
                <div style="width:100%;display: flex;align-items: center;">
                    <p style="font-size:16px;width:70px;">公司信息</p>
                    <p style="width:calc(100% - 70px);height:1px;background-color: #eeeeee;"></p>
                </div>
                <div v-html="company_desc" style="width:100%;line-height: 18px;font-size:12px;font-weight: 400;color:#73798c;">
                </div>
            </div>          
            <div @click="goJobEdit(jobPublishDetail[0].id)" style="cursor: pointer;margin-top:20px;width:100%;height:60px;display: flex;align-items: center;justify-content: center;border-top:1px solid #eeeeee;">
                 <div style="padding:8px 20px;background-color: #2d8cf0;color:#fff;font-size:14px;font-weight: 500;">职位申请</div>
            </div>
        </div>

        <div v-if="dialogVisible">
            <el-dialog title="招聘须知" :visible.sync="dialogVisible">
                <div class="applyKnow">
                    <ApplyKnow></ApplyKnow>
                </div>
            </el-dialog>
        </div>

    </div>
</template>
<script> 
 import ApplyKnow from './ApplyKnow.vue';
 export default {
   components: { ApplyKnow },
     name: 'JobDetail',
     data () {
         return {
            id:'',
            jobPublishDetail:[],
            company_desc:'  西安美术学院建校于1949年，其前身为西北人民艺术学院二分部，1949年7月由山西临汾迁至西安市长安县，更名为西北军政大学艺术学院，后历经西北艺术专科学校、西北美术专科学校等阶段，于1960年5月正式定名为西安美术学院，1994年学院整体迁至西安市雁塔区含光路南段。 西安美术学院自建校以来，广纳贤才、汇聚名师，立足卓绝的延安精神和厚重的历史文化传统，传承红色基因，形成了独具特色的艺术教育理念，为国家的建设发展培养了大批优秀艺术人才，创作了许多在中国当代美术史上具有深远影响的作品，为繁荣社会主义艺术事业做出了重要贡献，产生了良好的社会声誉和影响。改革开放以来，西安美术学院以育人为根本、以教学为中心、以教师为主体、以质量为生命、以繁荣文化为己任、秉承“艰苦创业，追求卓越”的精神，恪守“弘美厚德，借古开今”的校训，发挥地域优势，突出西部特色，率先将书法和民间美术纳入课堂教学，长期坚持并重视周秦汉唐历史文化、延安革命文艺、西北民族民间艺术、当代“长安画派”与“黄土画派”四大传统和绘画、书法、美术史论、中国民间美术“四大基础”教学，逐渐形成了基础雄厚、结构合理、特色鲜明的美术教育体系。',
            loading:true,
            dialogVisible:false,
        }
     },
     methods:{
        goJobEdit:function(publishId){
            this.dialogVisible=true;
            return;
            if (this.getSessionStorage('id')==null){
                this.$router.push({name:'Login'});
            }else{
                this.$confirm('职位申请前，请前往【个人中心】完善您的简历信息！', '提示', {
                    confirmButtonText: '前往个人中心',
                    cancelButtonText: '直接申请',
                    type: 'warning'
                    }).then(() => {
                        //前往个人中心
                        this.$router.push({name:'JobEdit'});
                    }).catch(() => {
                        //保存申请信息
                        var arr = [];
                        var jsont = { "id": this.getSessionStorage('id'), "publishId": publishId};
                        arr.push(jsont);

                        this.$axios.post(
                            this.Global.globalUrl+'/interface/saveApply.ashx',
                            JSON.stringify(arr),
                            {
                                header: { 'content-type': 'application/x-www-form-urlencoded' }
                            })
                        .then((res) => {
                            if (res.data.err==0){
                                this.$message({                                 
                                    duration:3000,
                                    type: 'success',
                                    message: '申请成功,可前往【个人中心-已投职位】查看!'
                                });
                            }else{
                                this.$message({                                   
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        })
                        .catch(() => {
                        })

                });

            }
        },
        getDataList:function(){
            var that=this;
            this.$axios.get(this.Global.globalUrl+'/interface/getJobpublishDetail.ashx'
                ,{params:{
                    id:this.id
                }}
                ).then((res) => {                  
                    that.jobPublishDetail=res.data.jobPublishDetail;                   
                })
                .catch(() => {
                })
                .finally(()=>{
                    this.loading=false;
                })

        },

     },
     mounted() {   
        this.$router.onReady(() => {
            if(this.$route.query.id != undefined && this.$route.query.id != null){
                console.log(this.$route.query.id);
                this.id=this.$route.query.id;
                this.getDataList();
            }
        })
     },

 }
</script>